export default "__VITE_ASSET__d7vX8djQ__"